import React from "react";
import { ChevronDown } from "lucide-react";

const Hero = () => {
  return (
    <section id="top" className="relative min-h-screen w-full overflow-hidden">
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://customer-assets-wrfwihn1.emergentagent.net/job_jovial-knuth-9/artifacts/cq58r7bq_662279886_933476889650877_8416271751074554009_n%20%281%29.jpg')",
        }}
      />
      <div className="absolute inset-0 hero-overlay" />

      {/* Content */}
      <div className="relative z-10 min-h-screen flex flex-col items-center justify-center px-6 text-center">
        <h1 className="font-serif-display text-white leading-[1.02] max-w-6xl animate-fade-up" style={{ fontSize: "clamp(2.6rem, 6.5vw, 6.5rem)" }}>
          <span className="block">ARHITECTURĂ</span>
          <span className="block">CARE CONSTRUIEȘTE</span>
          <span className="block" style={{ color: "var(--brand-gold)" }}>ECHIPE PUTERNICE</span>
        </h1>

        <p className="mt-8 text-white/85 text-lg md:text-xl max-w-2xl font-light animate-fade-up" style={{ animationDelay: "200ms" }}>
          Proiectăm spații care nu doar arată frumos — ele unesc oamenii și inspiră măreție.
        </p>

        <div className="mt-12 flex flex-col sm:flex-row gap-4 animate-fade-up" style={{ animationDelay: "400ms" }}>
          <a
            href="#projects"
            className="bg-white text-[#0e0e0f] px-8 py-4 rounded-full font-medium text-[15px] hover:bg-neutral-100 transition-colors duration-200 shadow-lg"
          >
            Vezi Proiectele Noastre
          </a>
          <a
            href="#contact"
            className="bg-[#0e0e0f] text-white px-8 py-4 rounded-full font-medium text-[15px] hover:bg-[#1e1e22] transition-colors duration-200 border border-white/10"
          >
            Hai să Colaborăm
          </a>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2">
        <span className="text-white/70 text-[11px] tracking-[0.28em] uppercase">Derulează pentru a descoperi</span>
        <ChevronDown size={22} className="text-white/80 scroll-indicator" />
      </div>
    </section>
  );
};

export default Hero;
